module.exports = __webpack_public_path__ + "static/media/9DESA21.f05dfca9.jpg";